<template> 
    <div class="row">
      <agenda  />
    </div>
</template>

<script>
import Agenda from './Agenda.vue'
export default {
  name: 'inicio',
  components: {
    'agenda': Agenda
  },
  created: function () {
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Inicio.vue?54b53de2